var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { forwardRef, Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { safeElement, responsiveArraySpreader, breakPointArrayCleaner } from "../../../utils";
import { Typography } from "../../Typography";
import { FieldMessage } from "../FieldMessage";
import { FiCheck } from "react-icons/fi";
import { media } from "../../../mixins";

var validTones = {
  danger: "danger",
  warning: "warning",
  success: "success",
  neutral: "neutral"
};

var Checkbox = forwardRef(function (_ref, ref) {
  var id = _ref.id,
      value = _ref.value,
      label = _ref.label,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      message = _ref.message,
      _ref$tone = _ref.tone,
      tone = _ref$tone === undefined ? validTones.neutral : _ref$tone,
      required = _ref.required,
      disabled = _ref.disabled,
      name = _ref.name,
      reserveMessageSpace = _ref.reserveMessageSpace,
      labelSize = _ref.labelSize,
      restProps = _objectWithoutProperties(_ref, ["id", "value", "label", "onChange", "onBlur", "onFocus", "message", "tone", "required", "disabled", "name", "reserveMessageSpace", "labelSize"]);

  var checked = restProps.checked;


  return React.createElement(
    Fragment,
    null,
    React.createElement(
      Label,
      _extends({ htmlFor: id, disabled: disabled }, restProps),
      React.createElement(CheckboxOld, {
        id: id,
        $as: "input",
        value: value,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        type: "checkbox",
        tone: tone,
        forwardedRefSafe: ref
        // tabIndex="1"
        , "aria-required": required,
        "aria-invalid": tone === validTones.danger,
        name: name,
        disabled: disabled
      }),
      React.createElement(
        CheckboxNew,
        {
          checked: checked,
          disabled: disabled,
          labelSizeArray: labelSize ? breakPointArrayCleaner(labelSize) : [1, 1, 1.25, 1.25]
        },
        !disabled && React.createElement(
          Fragment,
          null,
          React.createElement(Checkmark, { checked: checked }),
          React.createElement(FocusOverlay, null)
        )
      ),
      React.createElement(
        Typography,
        {
          $as: "span",
          size: labelSize,
          style: { position: "relative", transform: "translateY(-2px)" }
        },
        label
      )
    ),
    React.createElement(FieldMessage, {
      message: message,
      tone: tone,
      reserveMessageSpace: reserveMessageSpace,
      labelSize: labelSize
    })
  );
});

export { Checkbox };
Checkbox.displayName = "Checkbox";

Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired
} : {};

var Label = styled.label.withConfig({
  displayName: "Checkbox__Label",
  componentId: "sc-1ps8xu5-0"
})(["position:relative;display:flex;", ""], function (props) {
  return props.disabled ? "cursor: normal;" : "cursor: pointer;";
});

var FocusOverlay = styled.div.withConfig({
  displayName: "Checkbox__FocusOverlay",
  componentId: "sc-1ps8xu5-1"
})(["position:absolute;border-radius:4px;top:0;left:0;bottom:0;right:0;"]);

var CheckboxNew = styled(safeElement()).withConfig({
  displayName: "Checkbox__CheckboxNew",
  componentId: "sc-1ps8xu5-2"
})(["position:relative;flex-shrink:0;margin-right:0.5rem;display:flex;justify-content:center;align-items:center;", " ", " border-radius:4px;background-color:", ";box-shadow:inset 0px 0px 0px 1px ", ";", ""], "" /* height: 1.5rem;
                                                                                                                                                                                                                   width: 1.5rem; */, function (props) {
  return responsiveArraySpreader(function (value) {
    return css(["height:", "rem;width:", "rem;"], value * 1.0, value * 1.0);
  }, props.labelSizeArray);
}, function (props) {
  return props.checked ? props.theme.primary : props.theme.textNegative;
}, function (props) {
  return props.checked ? props.theme.primary : props.theme.formBorderColor;
}, function (props) {
  return props.disabled && "\n    background-color: rgba(0, 0, 0, 0.07);\n    box-shadow: inset 0px 0px 0px 1px rgba(0, 0, 0, 0.2);\n  ";
});

var Checkmark = styled(FiCheck).withConfig({
  displayName: "Checkbox__Checkmark",
  componentId: "sc-1ps8xu5-3"
})(["color:", ";opacity:0;", ""], function (props) {
  return props.checked ? props.theme.textNegative : props.theme.primary;
}, function (props) {
  return props.checked && "opacity: 1 !important;";
});

var CheckboxOld = styled(safeElement()).withConfig({
  displayName: "Checkbox__CheckboxOld",
  componentId: "sc-1ps8xu5-4"
})(["opacity:0;position:fixed;width:0;&:focus{& + ", " ", "{box-shadow:0px 0px 0px 3px ", ";}}", " ", ""], CheckboxNew, FocusOverlay, function (props) {
  return props.theme.formFocusColor;
}, "" /* &:hover {
      & + ${CheckboxNew} ${FocusOverlay} {
      box-shadow: 0px 0px 0px 3px ${props => props.theme.formFocusColor};
      }
      } */, media.only.computer(css(["&:hover{& + ", " ", "{opacity:0.2;}}"], CheckboxNew, Checkmark)));